var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNergie = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.42 51.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: ".27 10.69 17.91 .24 35.72 13.29 26 32.73 4.78 32.58 .27 10.69",
    fill: "#f63",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 37.6,
    width: 18.7,
    height: 2.84,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.95 28.61 45.95 49.43 28.15 49.43 28.15 28.61 33.18 28.61 34.2 25.77 25.31 25.77 25.31 37.6 26.84 37.6 26.84 40.44 25.31 40.44 25.31 52.27 48.79 52.27 48.79 25.77 43.24 25.77 40.28 28.61 45.95 28.61",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.31,
    y: 37.6,
    width: 1.53,
    height: 2.84,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.11,
    y: 33,
    width: 8.33,
    height: 1.87,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,32.03v3.82h10.29v-3.82h-10.29ZM60.94,35.36h-9.31v-2.84h9.31v2.84Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.63,35.36h9.31v-2.84h-9.31v2.84ZM52.11,33h8.33v1.87h-8.33v-1.87Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.11,
    y: 43.17,
    width: 8.33,
    height: 1.87,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,46.01h10.29v-3.82h-10.29v3.82ZM51.63,42.68h9.31v2.84h-9.31v-2.84Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,42.68h-9.31v2.84h9.31v-2.84ZM60.45,45.03h-8.33v-1.87h8.33v1.87Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.23 23.22 29.89 23.22 32.94 10.54 49.45 10.54 40.06 18.85 47.55 18.85 40.35 25.77 41.8 25.77 50.03 17.85 42.7 17.85 52.09 9.54 32.15 9.54 28.62 24.22 35.81 24.22 35.26 25.77 36.32 25.77 37.23 23.22",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.2 31.68 35.3 28.61 34.24 28.61 31.83 35.35 38.84 28.61 37.4 28.61 34.2 31.68",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.4 28.61 38.84 28.61 41.8 25.77 40.35 25.77 37.4 28.61",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.3 28.61 36.32 25.77 35.26 25.77 34.24 28.61 35.3 28.61",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.4 28.61 35.3 28.61 34.2 31.68 37.4 28.61",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.65 22.22 31.16 22.22 33.73 11.54 46.81 11.54 37.42 19.85 45.06 19.85 38.91 25.77 40.35 25.77 47.55 18.85 40.06 18.85 49.45 10.54 32.94 10.54 29.89 23.22 37.23 23.22 36.32 25.77 37.38 25.77 38.65 22.22",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.35 25.77 38.91 25.77 36.58 28 37.38 25.77 36.32 25.77 35.3 28.61 37.4 28.61 40.35 25.77",
    fill: "#000",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNergie);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/énergie.28059d2567d8584fba8fc9c27f74a9a1.svg";